var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecutiryModalImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 173,
    viewBox: "0 0 730 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 4.26562 142.651)",
    fill: "#56C773"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 5.21289 148.576)",
    fill: "#56C773"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 6.16016 154.501)",
    fill: "#56C773"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 0.473633 118.953)",
    fill: "#56C773"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 7.1084 160.426)",
    fill: "#56C773"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 1.42188 124.878)",
    fill: "#56C773"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 8.05664 166.35)",
    fill: "#56C773"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 2.37012 130.802)",
    fill: "#56C773"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 9.00391 172.274)",
    fill: "#56C773"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 729.643,
    height: 3,
    transform: "matrix(0.987447 -0.157953 -0.157953 -0.987447 3.31738 136.727)",
    fill: "#56C773"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M348.586 124.457C339.853 121.018 332.45 115.072 327.129 107.318C321.866 99.5067 319.032 90.4126 319.032 80.9686V58.583C319.032 57.8251 319.552 57.1839 320.246 57.009L333.202 53.9776V42.843C333.202 42.0269 333.78 41.3857 334.59 41.2691L364.029 37.1883V32L333.896 36.1973C330.599 36.6637 328.17 39.4619 328.17 42.843V49.9552L319.147 52.0538C316.14 52.7534 314 55.4933 314 58.583V80.9686C314 102.305 327.013 121.484 346.736 129.238L363.971 136V130.52L348.586 124.457Z",
    fill: "#64DE83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.852 52.0538L399.83 49.8969V42.843C399.83 39.5202 397.4 36.6637 394.104 36.1973L363.971 32V37.13L393.41 41.2108C394.162 41.3274 394.798 42.0269 394.798 42.7848V53.9193L407.753 56.9507C408.447 57.1256 408.968 57.7668 408.968 58.5247V80.9686C408.968 90.4126 406.192 99.5067 400.871 107.318C395.607 115.13 388.147 121.076 379.413 124.457L363.971 130.52V136L381.206 129.238C400.928 121.484 413.942 102.305 413.942 80.9686V58.583C414 55.4933 411.86 52.7534 408.852 52.0538Z",
    fill: "#56C773"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.201 42.8429V53.9774L320.246 57.0088C319.552 57.1837 319.031 57.825 319.031 58.5828V80.9684C319.031 90.4124 321.807 99.5066 327.128 107.318C332.392 115.13 339.853 121.076 348.586 124.457L363.971 130.52V127.78V39.6949V37.1299L334.532 41.2106C333.78 41.3272 333.201 42.0267 333.201 42.8429Z",
    fill: "#56C773"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M363.971 127.78V130.52L379.413 124.458C388.147 121.018 395.55 115.072 400.871 107.319C406.134 99.5069 408.968 90.4127 408.968 80.9687V58.5831C408.968 57.8252 408.447 57.184 407.753 57.0091L394.798 53.9777V42.8432C394.798 42.027 394.219 41.3858 393.41 41.2692L363.971 37.1885V39.7535V127.78Z",
    fill: "#47B062"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.007 77.2344H342.051V106.732H386.007V77.2344Z",
    fill: "#DCD3FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M353.156 72.8047H347.604V77.2352H353.156V72.8047Z",
    fill: "#B9AAEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M379.646 72.8047H374.094V77.2352H379.646V72.8047Z",
    fill: "#B9AAEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M379.645 68.4331C379.645 59.5139 372.473 52.2852 363.624 52.2852C354.775 52.2852 347.604 59.5139 347.604 68.4331V72.8053H353.156V68.4331C353.156 62.6035 357.841 57.8816 363.624 57.8816C369.408 57.8816 374.093 62.6035 374.093 68.4331V72.8053H379.645V68.4331V68.4331Z",
    fill: "#DCD3FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M367.787 88.078C367.787 85.9793 366.11 84.2305 363.97 84.2305C361.887 84.2305 360.152 85.9211 360.152 88.078C360.152 89.4188 360.846 90.5847 361.887 91.2843L360.152 99.6789H367.787L366.052 91.2843C367.093 90.5847 367.787 89.4188 367.787 88.078Z",
    fill: "#252735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecutiryModalImage);
export default __webpack_public_path__ + "static/media/SecutiryModalImage.d4c52e393d3c0d0998e38313cf0173b2.svg";
export { ForwardRef as ReactComponent };